import { render, staticRenderFns, recyclableRender, components } from "./Invoice-request.vue?vue&type=template&id=bf72f50e&scoped=true&"
var renderjs
import script from "./Invoice-request.vue?vue&type=script&lang=js&"
export * from "./Invoice-request.vue?vue&type=script&lang=js&"
import style0 from "./Invoice-request.vue?vue&type=style&index=0&id=bf72f50e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf72f50e",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "shop/pages/Invoice-request/Invoice-request.vue"
export default component.exports